import axiosInstances from '@/libs/axios-instances'
import { ref } from '@vue/composition-api'

export default function auth() {
  const user = ref({})
  const register = () => axiosInstances.users.post('v1/register', user.value).then(res => res)

  return { user, register }
}
